import i18next from 'i18next';

export const guessAgeGroupLabel = (age) => {
  if (!age) return null;

  let currentAgeGroup = 'Не определен';
  const ageGroups = {
    'constants:below_18': [0, 17],
    'constants:from_18_to_44': [18, 44],
    'constants:from_45_to_60': [45, 60],
    'constants:above_60': [61, 100],
  };
  Object.entries(ageGroups).forEach(([ageGroup, [from, to]]) => {
    if (from <= age && age <= to) currentAgeGroup = ageGroup;
  });

  if (!currentAgeGroup) return null;
  return i18next.t(currentAgeGroup);
};

export const getMetaFilters = (data) => {
  const updatedMetaObject = {};
  data?.meta?.forEach((m) => {
    updatedMetaObject[`meta.${m.key}__${m.operator.value}:${m.type.value}`] = m.value;
  });
  return updatedMetaObject;
};
